import React, { createRef, useState } from "react";
import CloseIcon from "../images/close.svg";
import { Cropper } from "react-cropper";
import "cropperjs/dist/cropper.css";

export default function ConfirmationPopup({
  type,
  activeData,
  onConfirm,
  setActiveData,
}) {
  // const [image, setImage] = useState('');
  const [cropData, setCropData] = useState("#");
  const cropperRef = createRef();
  return (
    <div className="bg-black bg-opacity-70 fixed z-[999] w-[100%] h-full left-0 top-0 flex justify-center items-center">
      <div className=" w-[95%] md:w-[480px] max-w-full bg-white   top-0 h-auto right-[320px] py-2 rounded-md">
        <div className="flex px-4 py-2 md:px-8 md:py-4 justify-between items-center">
          <h3 className="text-sm md:text-md font-semibold tracking-[-.15px]">
            {type === "feature"
              ? "Feature Confirmation"
              : type === "delete"
              ? "Delete Confirmation"
              : (activeData.status === 0 ? "Active Confirmation" : "Inactive Confirmation")}
          </h3>
          <div
            className="bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer"
            onClick={() => setActiveData(false)}
          >
            <img src={CloseIcon} className="w-4 h-4" />
          </div>
        </div>
        <div className="flex px-4 py-2 md:px-8 md:py-4 pt-4 w-full ">
          <p className="text-[14px] md:text-sm text-black font-normal">
            {type === "feature"
              ? activeData.status === 0
                ? "Are you sure want to feature?"
                : "Are you sure want to remove from featured?"
              : type === "delete"
              ? "Are you sure want to delete?"
              : activeData.status === 0
              ? "Are you sure you want to active?"
              : "Are you sure you want to inactive?"}
            {}
          </p>
        </div>
        <div className="flex mt-2 md:mt-4 px-4 py-2 md:px-8 md:py-4 pt-4">
          <button
            className="btn-md"
            onClick={() => onConfirm(activeData.id, activeData.status)}
          >
            Yes
          </button>
          <button
            className="ml-4 btn-md-disabled"
            onClick={() =>
              setActiveData((data) => ({
                ...data,
                show: false,
                id: null,
                status: null,
              }))
            }
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
}
